import clsx from 'clsx'
import classes from './Loader.module.css'

export function Loader({ className }: { className?: string }) {
  return <span className={clsx(classes.loader, className)} />
}
